<template>
  <fragment>
    <slider-preference-one-var-input
      v-for="(jQVariable, jQVarIndex) in jobQuestion.jobQuestionVariables"
      class="mb-4"
      :key="jQVariable.id"
      :job-question-variable="jQVariable"
      :job-question-initial-value="getInitialSliderValues(jQVarIndex)"
      :no-preference-value="noPreferenceValue"
      :with-label="jobQuestion.jobQuestionVariables.length > 1"
      @set-preference="onSetPreference"
    />
  </fragment>
</template>

<script>
import SliderPreferenceOneVarInput from '@/components/exchange/preference-charts-inputs/SliderPreferenceOneVarInput';
export default {
  name: 'SliderPreferenceInput',
  components: {
    SliderPreferenceOneVarInput,
  },
  props: {
    jobQuestion: {
      required: false,
    },
    forQuestionForm: {
      type: Boolean,
      default: false,
    },
    studyQuestion: {
      default: null,
    },
    noPreferenceValue: Number,
  },
  computed: {
    studyQuestionComputed: function () {
      return (
        this.studyQuestion || ((this.jobQuestion || {}).questions || [])[0]
      );
    },
  },
  methods: {
    getInitialSliderValues: function (varIndex) {
      if (
        this.studyQuestionComputed &&
        this.studyQuestionComputed.variables &&
        this.studyQuestionComputed.variables[varIndex] &&
        this.studyQuestionComputed.variables[varIndex].response
      ) {
        return this.studyQuestionComputed.variables[varIndex].response.value;
      }
      return null;
    },
    getResultsForVariable: function (varIndex) {
      if (
        this.studyQuestionComputed &&
        this.studyQuestionComputed.responses &&
        this.studyQuestionComputed.responses.results &&
        this.studyQuestionComputed.responses.results[varIndex]
      ) {
        return this.studyQuestionComputed.responses.results[varIndex].responses;
      }
      return null;
    },
    onSetPreference: function () {
      this.$emit('set-preference', ...arguments);
    },
    isDirty: function () {
      return false;
    },
    resetValidation: function () {
      return null;
    },
    hasErrors: function () {
      return false;
    },
    validate: function () {
      return null;
    },
  },
};
</script>

<style scoped></style>
